export default "__VITE_ASSET__9jy_LqXB__"